import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { transformIntoQueryParamString } from '@old/utils/service';

import {
  OrganizationIntegrations,
  OrganizationIntegrationsPayload,
  RevokeOrganizationIntegrationPayload,
} from './organization-integrations.types';

/** TIC-4249: integradores autorizados a ver / activar el monitoreo de la organización (vigentes y dados de baja). */
export async function organizationIntegrationsService({
  query: organizationId,
}: OrganizationIntegrationsPayload) {
  const query = transformIntoQueryParamString(organizationId, 'integrations');

  const { response, data } = await BACKEND.get<OrganizationIntegrations>(ENDPOINT.ORGANIZATIONS_V2, {
    query,
  });

  return {
    response,
    summary: data,
  };
}

/**
 * TIC-4249: el administrador de la organización da de baja la autorización de un integrador.
 * Devuelve la lista actualizada. Requiere permiso de escritura sobre la organización (403 si no).
 */
export async function revokeOrganizationIntegrationService({
  query: { organizationId, grantId },
}: RevokeOrganizationIntegrationPayload) {
  const query = transformIntoQueryParamString(organizationId, 'integrations', grantId);

  const { response, data } = await BACKEND.delete<OrganizationIntegrations>(ENDPOINT.ORGANIZATIONS_V2, {
    query,
  });

  return {
    response,
    summary: data,
  };
}
